import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";

const TableListStyle = makeStyles(() =>
  createStyles({
    wrapper: {
      padding: 0,
      paddingTop: 20,
      flexDirection: "column",
      height: "100%",
      "& .MuiDataGrid-root": {
        border: "none",
      },
      "& .MuiDataGrid-columnHeaders": {
        display: "none",
      },
      "& .MuiDataGrid-footerContainer": {
        border: "none",
      },
      "& .MuiTablePagination-displayedRows ": {
        border: "none",
      },

      "& .MuiDataGrid-row": {
        background:
          "linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.03))",
        backdropFilter: "blur(12px)",
        borderRadius: 12,
        border: "1px solid rgba(255,255,255,0.1)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        padding: 15,
        width: "100%",
        "& .MuiTypography-root": {
          whiteSpace: "break-spaces",
        },
        "& .MuiDataGrid-cell": {
          border: "none",
        },
        "& .actions-cell": {
          justifyContent: "end",
        },
      },
    },
    loader: {
      display: "block",
    },
    field: {
      width: "90%",
      marginLeft: "5%",
    },
    button: {
      width: "50%",
      marginLeft: "25%",
      marginTop: 30,
    },
    iconBtn: {
      float: "right",
      padding: 5,
    },
    pos: {
      color: "#fff",
      fontSize: 15,
      fontWeight: 400,
      textShadow: "none",
    },
    subpos: {
      width: "100%",
      fontSize: 14,
      color: "#fff",
      textShadow: "none",
      fontWeight: 300,
    },
    cardActions: {
      flexDirection: "row",
    },
    cardRoot: {
      width: "100%",
      marginBottom: 10,
      backgroundColor: "#47528c",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
  }),
);

export default TableListStyle;
